// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"dc7d2e53","251":"ef3cc8e0","334":"40a93d9d","348":"0c20fe22","571":"b10307b2"}[chunkId] + ".chunk.js";
};